import { Injectable } from '@angular/core';
import { EnumEnv } from '../models/enum-env';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

checkIfAlreadyExist< K extends {id:string}[] , T extends { id : string }>(array:  K, object : T){

    return array.find((n) => n.id == object.id);
  }

  getEnvironnement() : number{

    let env = EnumEnv.PROD;

    if(environment.apiUrl == "http://localhost:56000/"){
      env = EnumEnv.LOCAL
    }else if(environment.apiUrl == "https://coachcompanion.petit-tonneau.fr/"){
      env = EnumEnv.DEV
    }else if( environment.apiUrl == "LienARemplacerStage"){
      env = EnumEnv.STAGE
    }else {
      env = EnumEnv.PROD
    } 

    return env;

  }
}
